import { $color_grey_2, $color_brand_light_bg_default, $color_grey_6, $color_grey_9, $color_grey_5, $color_grey_7 } from '../pebbleGlobalToken/color.js';
import { $padding_none } from '../pebbleGlobalToken/spacing.js';

/**
 * 级联选择-控制级联item在鼠标悬浮时的背景颜色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-2
 */
var $cascader_control_item_bg_hover = $color_grey_2;

/**
 * 级联选择-控制级联item项在激活状态下的背景颜色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_text_active
 */
var $cascader_control_item_bg_active = $color_brand_light_bg_default;

/**
 * 级联选择-控制级联item项在禁用状态下的字体颜色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-6
 */
var $cascader_control_item_color_text_disabled = $color_grey_6;

/**
 * 级联选择-控制级联item项的padding。
 * @description enDesc: -
 * @description type: Color
 * @description value: $padding_none
 */
var $cascader_control_item_padding = $padding_none;

/**
 * 级联选择-控制级联item项hover时文字和箭头颜色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_grey_9
 */
var $cascader_control_item_text_hover = $color_grey_9;

/**
 * 默认使用的边框颜色, 用于分割不同的元素，例如：表单的分割线、卡片的分割线等。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-5
 */
var $cascader_color_border = $color_grey_5;

/**
 * 默认使用hover的边框颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-7
 */
var $cascader_color_border_hover = $color_grey_7;

/**
 * 边框选中态颜色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-9
 */
var $cascader_color_primary_hover = $color_grey_9;

export { $cascader_color_border, $cascader_color_border_hover, $cascader_color_primary_hover, $cascader_control_item_bg_active, $cascader_control_item_bg_hover, $cascader_control_item_color_text_disabled, $cascader_control_item_padding, $cascader_control_item_text_hover };
